const staticData = {
    static: {
        sections: [

            {
                title: 'Top Searches',
                slug: 'top-searches',
                searches: [
                    {
                        title: 'disney',
                    },
                    {
                        title: 'golf',
                    },
                    {
                        title: 'toy story',
                    },
                    {
                        title: 'tennis',
                    },
                    {
                        title: 'swim',
                    },
                    {
                        title: 'robe',
                    },
                    {
                        title: 'frozen',
                    },
                    {
                        title: 'pizza',
                    },
                    {
                        title: 'kimono',
                    },
                    {
                        title: 'lobster',
                    },
                    {
                        title: 'moana',
                    },
                ],
            },

            {
                title: 'Top Categories',
                slug: 'top-categories',
                categories: [
                    {
                        title: 'Fall Collection',
                        url: '/collections/fall-editorial',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/fall-collection-search.webp?v=1759282952',
                        imageAlt: 'Kids playing at playground',
                        vendor: 'Monica + Andy'
                    },
                    {
                        title: 'Back to School',
                        url: '/collections/back-to-school-editorial',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/back-to-school-search.webp?v=1759282952',
                        imageAlt: 'Girls in classroom wearing dresses',
                        vendor: 'Monica + Andy'
                    },
                    {
                        title: 'Halloween Collection',
                        url: '/collections/halloween',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/halloween-search.webp?v=1759282952',
                        imageAlt:
                            "Boy in halloween outfit",
                        vendor: 'Monica + Andy'
                    },
                    {
                        title: 'Pajama Shop',
                        url: '/collections/all-pajamas',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/pajama-shop-search.webp?v=1759282952',
                        imageAlt:
                            'Kids sitting cross legged on floor in pajamas',
                        vendor: 'Monica + Andy'
                    },
                    {
                        title: 'Dress Shop',
                        url: '/collections/all-dresses',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/dress-shop-search.webp?v=1759282952',
                        imageAlt: 'Girl sitting on floor in dress',
                        vendor: 'Monica + Andy'
                    },
                    {
                        title: 'The Disney Shop',
                        url: '/collections/disney-monica-andy',
                        imageSrc:
                            'https://cdn.shopify.com/s/files/1/2338/2917/files/disney-shop-search.webp?v=1759282952',
                        imageAlt: 'Girl in Disney dress',
                        vendor: 'Monica + Andy'
                    }
                ],
            },
        ],
    },
}

export default staticData
